import { ACTIONS } from "../constants"

import _ from "lodash";

const initialState = {
  searchResults: [],
  isTemps:[],
  searchBirthDate:null,
  structure: {},
  childrens: {},
  child: {},
  parentExist: false,
  isAuthenticated: false,
  totalSize: 0,
  isFetching: false,
  isLoading: false,
  hasMore: true,
  success: {
    create: false,
    edit: false,
    fetch: false,
    delete: false,
    updatePhone:false,
  },
  error: null,
  INStoValiodat:null,
  insError:false,
  insValid:false,
  evaxCode: ""
}


export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {

    // create child 
    case ACTIONS.FETCH_CREATECHILDREN_INIT: {
      return { ...state, isLoading: true, isFetching: true, error: null }
    }
    
    case ACTIONS.FETCH_CREATECHILDREN_SUCCEDED: {
      return { ...state, isLoading: false, error: null, success: { ...state.success, created: true }, child: payload,evaxCode:payload.evaxNumber }
    }
    case ACTIONS.FETCH_CREATECHILDREN_FAILED: {
      return { ...state, isLoading: false, error: payload }
    }


    case ACTIONS.FETCH_EVAXSEARCH_INIT: {
      return { ...state, isFetching: true, error: null }
    }
    case ACTIONS.FETCH_EVAXSEARCH_SUCCEDED: {
      console.log("ffffffffff22222",payload)
      let isTemps =[]
      if(!_.isEmpty(payload.childrenSet)){
          isTemps = payload.childrenSet.map(e=>{return{ numEvax: e?.numEvax, 
            isTemp:e.isTemp,
            // isTemp:true,
            
          }})
      }
      return { ...state, isFetching: false, isLoading: false, searchResults: payload,searchBirthDate: payload.birthDate,error: null, 
        success: initialState.success  ,isTemps}
    }
    case ACTIONS.FETCH_EVAXSEARCH_FAILED: {
      return { ...state, isFetching: false, error: payload, searchResults: [] }
    }
    case ACTIONS.FETCH_EVAXSEARCH1_INIT: {
      return { ...state, isFetching: true, error: null }
    }
    case ACTIONS.FETCH_EVAXSEARCH1_SUCCEDED: {
      return { ...state,
         isFetching: false,
          isLoading: false, 
          searchResults: payload,
          searchBirthDate: payload.birthDate,
          error: null,
          success: initialState.success 
        }

    }
    case ACTIONS.FETCH_EVAXSEARCH_FAILED: {
      return { ...state, isFetching: false, error: payload, searchResults: [] }
    }
    case ACTIONS.CHECK_PARENT_INIT: {
      return { ...state, isFetching: true, error: null }
    }
    case ACTIONS.CHECK_PARENT_SUCCEDED: {
      return { ...state, isLoading: true, parentExist: true }

    }
    case ACTIONS.CHECK_PARENT_FAILED: {
      return { ...state, parentExist: false, isFetching: false }
    }
    case ACTIONS.CLEAR_CHILDREN: {
      return { ...state, isLoading: false, error: null ,searchResults : [],parentExist:false,success:{create:false,edit:false,fetch:false,    updatePhone:false
      },evaxCode:"" }
    }
    case ACTIONS.CLEAR_SUCCESS : {
      return { ...state, isLoading: false, error: null ,success:{create:false,edit:false,fetch:false,updatePhone:false},insValid:false,insError:false,INStoValiodat:null }
    }
    case ACTIONS.DELETE_CHILD_INIT: {
      return { ...state, isLoading: true, error: null }
    }
    case ACTIONS.DELETE_CHILD_SUCCEDED: {
      console.log(payload)
      return { ...state, searchResults: [], isLoading: false, error: null, success: { ...state.success, delete: true } }
    }
    case ACTIONS.DELETE_CHILD_FAILED: {
      return { ...state, isLoading: false, error: null }
    }

    case ACTIONS.LINK_CHILD_INIT: {
      return { ...state, isLoading: true, error: null }
    }
    case ACTIONS.LINK_CHILD_SUCCEDED: {
      console.log("payload",payload.numEvax)  
      return { ...state, isLoading: false, error: null, success: { ...state.success, create: true }, evaxCode:payload?.numEvax }
    }
    case ACTIONS.LINK_CHILD_FAILED: {
      return { ...state, error: payload, isLoading: false }
    }

    // create foreign child 
    case ACTIONS.FETCH_CREATE_FOREIGN_CHILDREN_INIT: {
      return { ...state, isLoading: true, error: null }
    }
    case ACTIONS.FETCH_CREATE_FOREIGN_CHILDREN_SUCCEDED: {
      return { ...state, isLoading: false, error: null, success: { ...state.success, created: true }, child: payload,evaxCode:payload.numEvax }
    }
    case ACTIONS.FETCH_CREATE_FOREIGN_CHILDREN_FAILED: {
      return { ...state, isLoading: false, error: payload }
    }

    case ACTIONS.LINK_FOREIGN_CHILD_INIT: {
      return { ...state, isLoading: true, error: null }
    }
    case ACTIONS.LINK_FOREIGN_CHILD_SUCCEDED: {
      return { ...state, isLoading: false, error: null, success: { ...state.success, create: true }, evaxCode:payload?.numEvax }
    }
    case ACTIONS.LINK_FOREIGN_CHILD_FAILED: {
      return { ...state, error: payload, isLoading: false }
    }
    case ACTIONS.UPDATE_CITIZEN_PHONE_INIT: {
      return { ...state, isLoading: true, error: null }
    }
    case ACTIONS.UPDATE_CITIZEN_PHONE_SUCCEDED: {
      return { ...state, isLoading: false, error: null, success: { ...state.success, updatePhone: true } }
    }
    case ACTIONS.UPDATE_CITIZEN_PHONE_FAILED: {
      return { ...state, error: payload, isLoading: false }
    }
    case ACTIONS.VALIDAT_INS_INIT: {
      return { ...state, isLoading: false,
        error: null,
         success: initialState.success,
         insValid: false,
         insError:false ,
         INStoValiodat:null
         }
    }
  case ACTIONS.VALIDAT_INS_SUCCEDED: {
    const updatedIsTemps = state.isTemps.map(item =>{
      // if(item.numEvax === "138771773"){
      //     return { numEvax: "138771773", isTemp:false  }
      // }
      if(item.numEvax === payload.numEvax){
        return { numEvax: payload.numEvax, isTemp:false  }
      }
      else {
        return item
      }
    })
    return { ...state, isLoading: false,
      INStoValiodat:payload.numEvax,
      // INStoValiodat:"138771773",
      isTemps:updatedIsTemps,
      error: null,
        insValid: true 
      }
  }
  case ACTIONS.SET_IS_TEMP: { 
  const updatedIsTemps =state.isTemps.map(item =>{
    if(item.numEvax === payload.numEvax){
      return payload
    }else {
      return item
    }
  })
    return {
      ...state,
      isTemps:updatedIsTemps
       
    };
  }
  case ACTIONS.VALIDAT_INS_FAILED: {
    return { ...state, insError: payload , isLoading: false }
  }

    default: {
      return state
    }
  }
}
